import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import PublicTemplate from "@/components/PublicTemplate";
import PublicTemplateGallery from "@/components/PublicTemplateGallery";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Lightweight public routing: the /templates gallery and /template/:slug detail
// pages render as unauthenticated views that bypass the Supabase login flow.
const path = window.location.pathname;
const isGallery = /^\/templates\/?$/.test(path);
const templateMatch = path.match(/^\/template\/([^/]+)\/?$/);

let content = <App />;
if (isGallery) {
  content = <PublicTemplateGallery />;
} else if (templateMatch) {
  content = <PublicTemplate slug={decodeURIComponent(templateMatch[1])} />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>{content}</QueryClientProvider>
  </React.StrictMode>,
);
